export default __webpack_public_path__ + "static/media/Yeva.3122af55.png";